import { RevxDiscTextItem } from 'components/RevxDiscTextItem';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { useMemo } from 'react';

export const useSpecialSpecParameterList = () => {
  const specialList = useMemo(() => {
    return [
      {
        description: 'Pre-Sort First Class (500 Min.)',
        node: (
          <RevxFlexLayout direction="column" align="top">
            <span>Pre-Sort First Class</span>
            <RevxDiscTextItem>(minimum qty 500)</RevxDiscTextItem>
          </RevxFlexLayout>
        ),
      },
      {
        description: 'Pre-Sort Standard (Marketing Mail)(200 Min.)',
        node: (
          <RevxFlexLayout direction="column" align="top">
            <span>Pre-Sort Standard</span>
            <RevxDiscTextItem>Marketing Mail(minimum qty 200)</RevxDiscTextItem>
          </RevxFlexLayout>
        ),
      },
    ];
  }, []);

  return specialList;
};
